var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM2.73107 10C2.73107 14.0145 5.98548 17.2689 10 17.2689C14.0145 17.2689 17.2689 14.0145 17.2689 10C17.2689 5.98548 14.0145 2.73107 10 2.73107C5.98548 2.73107 2.73107 5.98548 2.73107 10Z",
    fill: "#24AA49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 11.7554 19.5379 13.4798 18.6603 15C17.7826 16.5202 16.5202 17.7826 15 18.6603C13.4798 19.5379 11.7554 20 10 20C8.24463 20 6.52019 19.5379 5 18.6603C3.47981 17.7826 2.21743 16.5202 1.33975 15C0.462062 13.4798 -1.53459e-07 11.7554 0 10C1.53459e-07 8.24463 0.462063 6.52019 1.33975 5C2.21743 3.47981 3.47981 2.21743 5 1.33975L6.35697 3.69008C5.24935 4.32957 4.32957 5.24935 3.69008 6.35697C3.0506 7.46459 2.71394 8.72103 2.71394 10C2.71394 11.279 3.0506 12.5354 3.69008 13.643C4.32957 14.7507 5.24935 15.6704 6.35697 16.3099C7.46459 16.9494 8.72103 17.2861 10 17.2861C11.279 17.2861 12.5354 16.9494 13.643 16.3099C14.7507 15.6704 15.6704 14.7507 16.3099 13.643C16.9494 12.5354 17.2861 11.279 17.2861 10H20Z",
    fill: "#24AA49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidIcon);
export default __webpack_public_path__ + "static/media/Paid_icon.10509fe92a9b78743e1d5bcea85f6aa8.svg";
export { ForwardRef as ReactComponent };